// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import { withStyles } from "@material-ui/core";
import { Button } from "./button";
import { DefaultParameterDialog } from "../defaultparamters";
import { compose } from "recompose";
import { withRouter } from "react-router";
import classnames from "classnames";
import { TranslationContext } from "../translation";
import { withStore } from "../store/withstore";

const styles = {
	wrapper: {
		backgroundColor: "#f0f1f2",
		boxShadow: "0 -3px 3px 0 rgba(48,60,73,0.15)"
	},
	container: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "70px",

		marginLeft: 'auto',
		marginRight: 'auto',
		maxWidth: 1200,
		width: '100%',

		"&.result": {
			justifyContent: "space-around"
		}
	}
};

const Footer = ({ classes, history, storeAction }) => {
	const isResultPage = history.location.pathname === "/tco-lcc/result";
	const { translate } = useContext(TranslationContext);

	const newCalculation = () => {
		storeAction.reset();
		history.push("/tco-lcc");
	};

	return (
		<div className={classnames({ [classes.wrapper]: isResultPage })}>
			<div className={classnames(classes.container, { result: isResultPage })}>
				{isResultPage && (
					<Button
						variant="outlined"
						onClick={() => history.push("/tco-lcc/configuration")}
					>
						{translate("common.calculation.change")}
					</Button>
				)}
				<DefaultParameterDialog/>
				{isResultPage && (
					<Button
						variant="contained"
						onClick={newCalculation}
						color="primary"
					>
						{translate("common.calculation.new")}
					</Button>
				)}
			</div>
		</div>
	);
};

export default compose(
	withStore,
	withRouter,
	withStyles(styles)
)(Footer);



// WEBPACK FOOTER //
// ./src/tco/components/footer.js